export const PAYMENT_ASSERT = 'payment.PAYMENT_ASSERT';



// WEBPACK FOOTER //
// ./src/types/payment.js